<div class="grid">
  <div class="col-12">
    <div class="d-flex align-items-center" style="gap: 20px">
      <!-- Maintain consistent gap -->
      <div class="flex-grow-1">
        <p-dropdown
          appendTo="body"
          placeholder="Select a Rate Card preset"
          [options]="presetOptions"
          [(ngModel)]="selectedPresetId"
          [style]="{ width: '100%' }"
          (onChange)="onPresetSelected($event)"
        ></p-dropdown>
      </div>
      <div>
        <button
          type="button"
          pButton
          label="Apply Preset"
          (click)="applyPreset()"
          [disabled]="!selectedPreset || isBusy"
          class="ui-button alternate-btn"
          aria-label="Apply Rate Card Preset"
        >
          Apply Preset
        </button>
      </div>
    </div>
  </div>
</div>
